import React, { useState } from 'react';
import BotonBuscarChico from '../botones/BotonBuscarChico.js';
import PopupBuscarEquipo from '../../popups/PopupBuscarEquipo.js';
import CampoEditableTexto from '../campos/CampoEditableTexto.js';
import styles from './CampoBuscarEquipo.module.css';

const CampoBuscarEquipo = (props) => {
  const prefiltro = props.prefiltro;
  const objetoFiltro = props.objetoFiltro;
  const width = props.width;
  const editar = props.editar;
  const nombre = props.nombre;
  const equipo = props.valor;
  const tipoInicial = props.tipoInicial;
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [nombreBuscar, setNombreBuscar] = useState('');

  const onCampoChange = (nombre, valor) => {
    setNombreBuscar(valor);
  };

  const onEquipoElegido = (equipoElegido) => {
    props.onEquipoElegido(nombre, equipoElegido);
    setMostrarPopup(false);
    setNombreBuscar(equipoElegido.nombre);
  };

  const onClickBuscar = (event) => {
    event.preventDefault();
    setMostrarPopup(true);
  };

  const onCancelarPopup = () => {
    setMostrarPopup(false);
  };

  let htmlNombreEquipo = null;
  if (equipo) {
    htmlNombreEquipo = (
      <div className={`${styles.nombreEquipo}`} style={{ width }}>
        {equipo.nombre}
      </div>
    );
  } else {
    htmlNombreEquipo = (
      <CampoEditableTexto
        nombre={nombre}
        valor={nombreBuscar}
        largo={50}
        editar={editar}
        width={width}
        onChange={onCampoChange}
        onPressEnter={onClickBuscar}
      />
    );
  }

  return (
    <div className={`${styles.contenedor}`}>
      {htmlNombreEquipo}
      <BotonBuscarChico estilo={`${styles.boton}`} onClick={onClickBuscar} />
      <PopupBuscarEquipo
        prefiltro={prefiltro}
        objetoFiltro={objetoFiltro}
        visible={mostrarPopup}
        texto={equipo ? equipo.nombre : nombreBuscar}
        tipoInicial={tipoInicial}
        tieneEquipoSeleccionado={!!equipo}
        onEquipoElegido={onEquipoElegido}
        onCancelar={onCancelarPopup}
      />
    </div>
  );
};

export default CampoBuscarEquipo;
